module.exports = __webpack_public_path__ + "static/hero_video_3s-aadcf0b400a6f36dbc60f5337583a741.mp4";